import Skeleton from '@mui/material/Skeleton';

export const SummarySkeleton = () => <Skeleton width="100%" height={80} />;
